import { combineReducers } from 'redux';
import webFormData from './web-form';
import directDebit from './direct-debit';

export default combineReducers({
  directDebit,
  webFormData,
});
